export const backend = process.env['REACT_APP_CORS_HOST'];
const test = process.env['REACT_APP_ENV'] === 'test';

const loggedOutEndpoints = ['/login', '/reset', '/register', '/createAccountConsultant'];

export const forceHomeHref = () => {
    let loc = (location.href).split('#')[1] || '/';
    loc = loc.split('?')[0];
    if (location.href.includes('/checklist.docx')) {
        return false;
    }
    if (loc === '/registerConsultantAdmin') {
        return false;
    }
    if (loc.startsWith('/createAccountConsultantAdmin')) {
        return false;
    }
    return (loc === '/') || loggedOutEndpoints.some(prefix => loc.startsWith(prefix));
};

export const forceLoginHref = () => {
    let loc = (location.href).split('#')[1] || '/';
    loc = loc.split('?')[0];
    if (loc === '/' || loc === '/proposal/new') {
        return true;
    }
    if (['/kycAdmin'].some(prefix => loc.startsWith(prefix))) {
        return true;
    }
    if (['/createAccountConsultant', '/kyc', '/proposal3', '/proposal-profile'].some(prefix => loc.startsWith(prefix))) {
        return false;
    }
    return !forceHomeHref();
};

export const simpleRequest = async (method: string, path: string, params?: object, ignore403?: boolean) => {
    const data = new FormData();
    if (params) {
        for (const k of Object.keys(params)) {
            const v = params[k];
            data.set(k, v);
        }
    }
    const response = await fetch(backend + path, {body: data, method, credentials: 'include'});
    if (!test && response.status === 403 && forceLoginHref() && !ignore403) {
        location.reload();
    }
    return response;
};

export const testsimpleRequest = async (method: string, path: string, params?: object, ignore403?: boolean) => {
    const data = new FormData();
    if (params) {
        for (const k of Object.keys(params)) {
            const v = params[k];
            data.set(k, v);
        }
    }
    const response = await fetch(backend + path, {body: data, method, credentials: 'include'});
    if (!test && response.status === 403 && forceLoginHref() && !ignore403) {
        location.reload();
    }
    return response;
};

export const expunge = () => {
    try {
        fetch('http://localhost:13000/expunge');
    } catch (e) {

    }
};

export const get = async (path: string, params?: object, ignore403?: boolean) => {
    const p = new URLSearchParams();
    if (params) {
        for (const k of Object.keys(params)) {
            const v = params[k];
            if (v) {
                p.set(k, params[k]);
            }
        }
    }
    const response = await fetch(backend + path + '?' + p.toString(), {method: 'GET', credentials: 'include'});
    if (!test && response.status === 403 && forceLoginHref() && !ignore403) {
        location.reload();
    }
    return response;
};

export const del = async (path: string, params?: object, ignore403?: boolean) => {
    const p = new URLSearchParams();
    if (params) {
        for (let k in params) {
            if (params.hasOwnProperty(k)) {
                p.set(k, params[k]);
            }
        }
    }
    const response = await fetch(backend + path + '?' + p.toString(), {method: 'DELETE', credentials: 'include'});
    if (!test && response.status === 403 && !ignore403 && forceLoginHref()) {
        location.reload();
    }
    return response;
};

export const uploadFile = async (method: string, path: string, params: object) => {
    const data = new FormData();
    for (const k of Object.keys(params)) {
        const v = params[k];
        if (v instanceof Blob) {
            data.set(k, v);
        } else if (v instanceof Array) {
            v.forEach((v2: any, i: number) => {
                if (v2 instanceof Blob) {
                    data.set(k + i, v2);
                }
            });
        }
    }
    data.set('state', JSON.stringify(params));
    const response = await fetch(backend + path, {body: data, method, credentials: 'include'});
    if (!test && response.status === 403 && forceLoginHref()) {
        location.reload();
    }
    return response;
};

export const filterVals = (m: object) => {
    const out = {};
    for (const k in m) {
        if (m.hasOwnProperty(k)) {
            const v = m[k];
            if (v || v === false || v === '') {
                out[k] = v;
            }
        }
    }
    return out;
};

export const stringifyMap = (m: Map<any, any>) => JSON.stringify(
    Array.from(m).reduce(
        (obj, [key, value]) => {
            obj[key] = value;
            return obj;
        },
        {}));

export const selectKeys = (m: object, ks: string[]) => {
    const result = {};
    for (const k of ks) {
        const v = m[k];
        if (v || v === false || v === '') {
            result[k] = v;
        }
    }
    return result;
};

export const href = (path: string, params: object, useBackend?: boolean) => {
    if (useBackend) {
        path = backend + path;
    }
    path += '?';
    for (const k in params) {
        if (params.hasOwnProperty(k)) {
            path += `&${k}=${params[k]}`;
        }
    }
    return path;
};
export const hrefBody = (params: object) => href(location.href.split('?')[0], params);



// WEBPACK FOOTER //
// ./src/client/core.tsx